import {Component, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { HelpService } from '../help.service';
import {map, takeUntil} from "rxjs/operators";
import {HelpModel} from "../help.model";
import {firstValueFrom, Observable} from "rxjs";
import {BaseComponent} from "../../base-component";
import {LocalizationModel} from "../../system/languages/localization.model";

@Component({
  selector: 'app-help-state',
  templateUrl: './help-state.component.html',
  styles: []
})
export class HelpStateComponent extends BaseComponent implements OnInit {
  topicId: string;
  help: HelpModel;
  isLoading = signal(false)
  topics$: Observable<LocalizationModel[]>;
  apiKey = 'bu5k4a2gy2ldgzp5r57lzu8c4ja77wc9w8bpueo7o67ellz9';

  constructor(private route: ActivatedRoute, public helpService: HelpService, private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.getTopics();
    this.route.params.pipe(takeUntil(this.componentDestroyed)).subscribe(params => {
      this.topicId = params.helpId;
      if (this.topicId) {
        this.getHelp(this.topicId);
      }
    });
  }

  private getTopics() {
    this.topics$ = this.helpService.getTopics();
  }

  getHelp(id: string, insistCore: boolean = null) {
    this.isLoading.set(true);
    this.helpService.getHelpById(id, insistCore).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.isLoading.set(false);
      this.help = value;
      this.helpService.hasBaseVersion = !!value.CoreVersionModifiedDate && !!value.UserVersionModifiedDate;
    });
  }

  create() {
    this.helpService.isEditMode = true;
  }

  edit() {
    this.helpService.isEditMode = !this.helpService.isEditMode;
  }

  save() {
    this.helpService.save(this.help).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      this.help = value;
      this.getTopics();
    });
  }

  image_upload_handler: any = (blobInfo, success, failure, progress) => {
    return new Promise(async (resolve, reject) => {
      return await firstValueFrom(this.helpService.upload(blobInfo).pipe(map(value => {
        if (value?.Warnings?.length) {
          return reject( {message: value.Warnings.map(warning => warning.Messages.join('\n')).join('\n')});
        }
        if (value.data) {
          return resolve(value.data);
        }
        return reject( {message: 'File upload error'});
      })));
    });
  };

  addTopic(topic: string) {
    this.helpService.addKeys(['help.' + topic]).subscribe(value => {
      this.getTopics();
      this.router.navigate(['help', value[0].Id]).catch(reason => console.log(reason));
    });
  }
}
